import { environment } from '@environments/environment';
import { BaseComponent } from '@base/component/base.component';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, NavigationStart } from '@angular/router';
import { Location } from '@angular/common';
import * as THEOplayer from '../../assets/js/TheoPlayer/THEOplayer.js';
import { addBookmark, getAssetDetails, getAssetPreplay } from '../api/assets';
import { attachABRResetLogic, languages, getDRM } from 'src/utils/theoPlayer';
import { AssetGroupDetailService } from '@asset-detail/services/asset-group-details.service';
import { AssetGroupDetail } from '@asset-detail/model/asset-group-detail.model.js';
import { AssetGroupListing } from '@asset-detail/model/asset-group-listing.model.js';
import { Subscription, interval } from 'rxjs';
import { take, map } from 'rxjs/operators';

declare var $: any;
@Component({
    selector: 'app-video-page-player',
    templateUrl: './video-page-player.component.html',
    styleUrls: ['./video-page-player.component.css'],
})
export class VideoPagePlayerComponent extends BaseComponent implements OnInit, OnDestroy {
    assetId: string;
    assetTitle: string;
    assetData = null;
    videoType: 'movie' | 'trailer' | 'live';
    bookmarkDuration: number;
    setBookmark: boolean;
    isGeolocationAllowed: boolean = true;
    playerObject: any;
    preplayParameters;
    addBookmarkInterval: NodeJS.Timer;
    isLoading: boolean = false;
    certification: string;
    certificationText: string;

    showCertification: boolean = true;
    certificationClass: string = 'hidden';
    assetGroupId: string;
    assetGroupData: AssetGroupDetail;
    seasonPath: any = 0;
    episodesList: AssetGroupListing;
    introStart: number;
    introEnd: number;
    creditsStart: number;
    showSkipButton: boolean = false;
    showSkipButtonFirstTime: boolean = false;
    showNextEpisodeButton: boolean = false;
    isAdPlaying: boolean = false;
    adStartListener: any;
    adEndListener: any;
    activeItem: string = '';
    assetSeason: any;
    isLastEpisode: boolean = false;
    timerValue: number;
    timerFirstTime: boolean = true;
    showTimer: boolean = false;
    timerSubscription: Subscription;
    showRepeatEpisodeButton: boolean = true;
    showActionIndicator: boolean = false;
    actionIndicator: { icon: string; animationClass: string };
    timeoutId: any;

    route: ActivatedRoute;
    routePath: string;

    constructor(
        activateRoute: ActivatedRoute,
        private location: Location,
        private assetGroupService: AssetGroupDetailService
    ) {
        super();
        this.route = activateRoute;
        this.routePath = this.route.snapshot.url[0].path;
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.activeItem = 'episodioActual';
    }

    async ngOnInit() {
        this.destroyPlayer();
        document.addEventListener('keydown', this.getPressedKey.bind(this));
        if (!this.checkAvailableIosVersion()) return;

        this.router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                this.timerFirstTime = true;
            }
        });
        this.setRouteParams();
        this.setVideoType();

        if (!this.validateAuthentication()) return;

        await this.getAssetData();

        if (!this.validateAuthorization()) return;

        if (this.isGeolocationAllowed) this.showVideo();

        this.setCertificationData();
        if (
            this.assetData.title.search(/T(\d{2})/) !== -1 ||
            this.assetData.title.search(/T(\d{3})/) !== -1
        ) {
            this.getAssetGroupData(this.assetGroupId);
            this.createEpisodesButton();
            this.addCloseEpisodesEventListener();
        }

        const introTimes = this.assetData.csaiMidRollDuration
            ? this.assetData.csaiMidRollDuration.split('-')
            : ['0:00', '0:00', '2000:00'];
        this.introStart = this.timeToSeconds(introTimes[0]);
        this.introEnd = this.timeToSeconds(introTimes[1]);
        this.creditsStart = this.timeToSeconds(introTimes[2]);
        this.playerObject.addEventListener('timeupdate', this.onTimeUpdate.bind(this));
    }

    destroyPlayer() {
        if (this.playerObject && this.playerObject.destroy) {
            this.playerObject.destroy();
        }
        this.playerObject = undefined;
        this.assetData = null;
    }

    setRouteParams() {
        this.route.params.subscribe((params) => {
            this.assetId = params.id;
            this.assetTitle = params.title;
            this.seasonPath = params.seasonPath;
        });
    }

    setVideoType() {
        this.videoType = this.routePath === 'trailer-page' ? 'trailer' : 'movie';
        this.setBookmark = this.videoType === 'movie';
    }

    validateAuthentication(): boolean {
        if (!this.isLoggedIn && this.videoType !== 'trailer') {
            this.goToAssetPage();
            return false;
        }
        return true;
    }

    setCertificationData() {
        if (this.assetData.certification[0]) {
            this.certification =
                this.certificationDictionary[this.assetData.certification[0].certificationName][
                    'code'
                ];
            this.certificationText =
                this.certificationDictionary[this.assetData.certification[0].certificationName][
                    'description'
                ];
        }
        setTimeout(() => {
            this.certificationClass = 'visible';
            setTimeout(() => {
                this.certificationClass = 'hidden';
                setTimeout(() => {
                    this.showCertification = false;
                }, 1000);
            }, 8000);
        }, 1000);
    }

    validateAuthorization(): boolean {
        if (!this.assetData.casUserWatchAsset && this.videoType !== 'trailer') {
            this.goToAssetPage();
            return false;
        }
        return true;
    }

    createEpisodesButton() {
        const button = THEOplayer['videojs'].getComponent('Button');
        const episodesButton = THEOplayer['videojs'].extend(button, {
            constructor: function () {
                button.apply(this, arguments);

                const tooltipSpan = document.createElement('span');
                tooltipSpan.className = 'theo-button-tooltip vjs-hidden';
                tooltipSpan.innerText = 'Capítulos';

                function toggleTooltip() {
                    tooltipSpan.classList.toggle('vjs-hidden');
                }

                this.el().addEventListener('mouseover', toggleTooltip);
                this.el().addEventListener('mouseout', toggleTooltip);
                this.el().appendChild(tooltipSpan);
            },
            handleClick: function () {
                const episodesMenu = document.querySelector(
                    '.episodes-menu-overlay'
                ) as HTMLElement;
                const closeVideoBtn = document.querySelector('.pip-close-icon') as HTMLElement;
                episodesMenu.style.display = 'flex';
                setTimeout(() => {
                    episodesMenu.classList.add('visible');
                    closeVideoBtn.style.display = 'none';
                }, 50);
            },
            buildCSSClass: function () {
                return 'custom-episodes-icon vjs-control vjs-button';
            },
        });
        THEOplayer['videojs'].registerComponent('episodesButton', episodesButton);
        this.playerObject.ui.getChild('controlBar').addChild('episodesButton', {});
    }

    addCloseEpisodesEventListener() {
        document.querySelector('.close-episodes-btn').addEventListener('click', function () {
            var episodesContainer = document.querySelector('.episodes-menu-overlay') as HTMLElement;
            const closeVideoBtn = document.querySelector('.pip-close-icon') as HTMLElement;
            episodesContainer.classList.remove('visible');
            setTimeout(() => {
                episodesContainer.style.display = 'none';
                closeVideoBtn.style.display = 'block';
            }, 500);
        });
    }

    checkAvailableIosVersion() {
        const split1 = navigator.userAgent.split('iPhone OS ');
        const split2 = split1 && split1.length > 1 ? split1[1].split('_') : undefined;
        const iosVersion = split2 && split2.length > 0 ? split2[0] : undefined;
        const isSafari =
            navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('CriOS');
        if (!iosVersion || isSafari) return true;
        if (Number(iosVersion) <= 12) {
            $('#ios-version-not-allowed-modal').modal('show');
            $('#pip-close').hide();
            return false;
        }
        return true;
    }

    goToAssetPage() {
        if (this.assetTitle) {
            this.router.navigate(['/video', this.assetTitle.split(/\s/).join(''), this.assetId]);
        } else {
            this.location.back();
        }
    }

    goToAssetGroupPage() {
        if (this.assetGroupId) this.router.navigate(['/season', this.assetGroupId]);
    }

    goToAssetVideo(assetTitle: string, assetId: string) {
        this.router.navigate([
            '/video-page',
            assetTitle.split(/\s/).join(''),
            assetId,
            this.seasonPath,
        ]);
    }

    async getAssetData() {
        const response = await getAssetDetails(this.assetId);
        this.assetData = response.data[0];
        if (
            this.assetData.assetGroup &&
            this.assetData.assetGroup[1] &&
            !this.assetData.assetGroup[1].assetGroupName.toUpperCase().includes('SVOD') &&
            !this.assetData.assetGroup[1].assetGroupName.toUpperCase().includes('TVOD')
        )
            this.assetGroupId = this.assetData.assetGroup[1].assetGroupId;
        else
            this.assetGroupId = this.assetData.assetGroup[0]
                ? this.assetData.assetGroup[0].assetGroupId
                : null;
        this.bookmarkDuration = Number(this.assetData.bookmarkDuration) || 0;
        this.isGeolocationAllowed = !!response.data[0].geoStatus;
        if (this.assetData.contentType === 'Live') this.videoType = 'live';
        const drm = getDRM();

        this.preplayParameters = await getAssetPreplay({
            assetId: this.videoType === 'trailer' ? this.assetData.mappedtrailer : this.assetId,
            drm,
        });
        this.assetSeason = this.assetData.title.match(/T(\d{2})/)
            ? parseInt(this.assetData.title.match(/T(\d{2})/)[1])
            : null;
    }

    showVideo() {
        const element = document.querySelector('.theoplayer-container') as HTMLElement;
        this.playerObject = new THEOplayer.Player(element, {
            libraryLocation: 'src/assets/js/TheoPlayer/',
            license: environment.theoPlayer,
            ui: {
                language: 'esp',
                languages: languages,
            },
        });

        if (this.videoType === 'trailer') {
            this.playerObject.source = {
                sources: {
                    integration: 'verizon-media',
                    id: this.preplayParameters.data.preplay.cid,
                    preplayParameters: this.preplayParameters.data.preplay,
                    assetType: 'asset',
                    contentProtected: true,
                },
            };

            const onAddTrack = () => {
                // Set the initial quality value to the lowest one
                this.playerObject.videoTracks[0].targetQuality =
                    this.playerObject.videoTracks[0].qualities[0];
                this.playerObject.addEventListener('progress', () =>
                    attachABRResetLogic(this.playerObject)
                );
            };
            this.playerObject.videoTracks.addEventListener('addtrack', onAddTrack);
            return;
        }

        const hasCid = !!this.preplayParameters.data.preplay.cid;
        this.playerObject.source = {
            sources: {
                integration: 'verizon-media',
                id: hasCid
                    ? this.preplayParameters.data.preplay.cid
                    : {
                          userId: this.preplayParameters.data.preplay.oid,
                          externalId: this.preplayParameters.data.preplay.eid,
                      },
                preplayParameters: this.preplayParameters.data.preplay,
                assetType: hasCid ? 'asset' : 'channel',
                contentProtected: true,
            },
        };

        const onAddTrack = () => {
            const highQualities = this.playerObject.videoTracks[0].qualities.filter(
                (quality) => quality.height == 1080
            );
            const quality = highQualities.length
                ? this.playerObject.videoTracks[0].qualities[0]
                : null;

            // start with the highest quality possible
            this.playerObject.videoTracks[0].targetQuality = quality;
        };

        const onTimePaused = async () => {
            clearInterval(this.addBookmarkInterval);
            if (this.setBookmark) {
                await this.addBookmark();
            }
        };

        const onVideoPlay = () => {
            if (this.setBookmark) {
                this.addBookmarkInterval = setInterval(() => {
                    this.addBookmark();
                }, 30000);
            }
        };

        const onLoadedData = () => {
            this.playerObject.currentTime = this.bookmarkDuration;
        };

        const onError = () => {
            console.log('error');
        };

        // Se comenta momentaneamente la siguiente llamada por problemas en el reproductor de video
        // this.playerObject.videoTracks.addEventListener('addtrack', onAddTrack);

        if (this.videoType === 'movie') {
            this.playerObject.addEventListener('loadedmetadata', onLoadedData);
            this.playerObject.addEventListener('pause', onTimePaused);
            this.playerObject.addEventListener('play', onVideoPlay);
            this.playerObject.addEventListener('error', onError);
        }
    }
    public getAssetGroupData(assetGroupId: string): void {
        const assetGroupDetailRequest = {
            path: assetGroupId,
        };
        let genreFiterString = '?filter=' + encodeURI(JSON.stringify(assetGroupDetailRequest));
        this.assetGroupService.getAssetGroupDetails(genreFiterString).subscribe(
            (res) => {
                if (res !== undefined && res.success == true) {
                    this.assetGroupData = res;
                    // this.seasonPath = this.seasonPath || this.assetGroupData.data[0].assetCategory[this.assetSeason - 1].path;
                    this.getAssetGroupListing(this.seasonPath);
                }
            },
            (err) => {
                console.log(err);
            }
        );
    }
    public getAssetGroupListing(seasonPath: string): void {
        this.seasonPath = seasonPath;
        const assetGroupListingRequest = {
            path: seasonPath,
            type: 'asset_category',
            deviceTypeId: '1',
        };
        let assetGroupListingString = `?filter=${encodeURI(
            JSON.stringify(assetGroupListingRequest)
        )}`;
        this.assetGroupService.getAssetListing(assetGroupListingString).subscribe(
            (res) => {
                if (res !== undefined && res.success === true) {
                    res.data.forEach((asset, i) => {
                        // Set "oneplay-content" in img paths
                        asset.vodOrLivePosterImageFilePath = this.setTenantBucket(
                            asset.vodOrLivePosterImageFilePath
                        );
                        asset.vodClosedCaptionFilePath = this.setTenantBucket(
                            asset.vodClosedCaptionFilePath
                        );
                        asset.verticalFilePath = this.setTenantBucket(asset.verticalFilePath);
                        asset.horizontalFilePath = this.setTenantBucket(asset.horizontalFilePath);

                        // Set default duration if not populated
                        if (asset.bookmarkDuration && !asset.duration) {
                            asset.duration = 2700;
                            asset.progressBarBookmarkWidth =
                                ((asset.bookmarkDuration * 100) / asset.duration).toString() + '%';
                        }
                    });
                    this.episodesList = res.data;
                    this.isLastEpisodeInSeason();
                }
            },
            (err) => {
                console.log(err);
            }
        );
    }

    timeToSeconds(time: string): number {
        const [minutes, seconds] = time.split(':').map(Number);
        return minutes * 60 + seconds;
    }

    onTimeUpdate() {
        // Monitor the current time of the player
        const currentTime = this.playerObject.currentTime;
        const currentAd = this.playerObject.verizonMedia.ads.currentAds;
        this.isAdPlaying = currentAd.length > 0;

        // Show the skip entry button if the current time is within the range of the entry
        if (
            currentTime > this.introStart &&
            currentTime <= this.introEnd &&
            !this.showSkipButtonFirstTime &&
            currentAd.length == 0
        ) {
            this.showSkipButton = true;
            setTimeout(() => {
                this.showSkipButton = false;
                this.showSkipButtonFirstTime = true;
            }, 15000);
        } else {
            this.showSkipButton = false;
        }

        if (
            currentTime >= this.creditsStart &&
            !this.isAdPlaying &&
            this.timerFirstTime &&
            this.assetGroupData
        ) {
            const episodesMenu = document.querySelector('.episodes-menu-overlay') as HTMLElement;
            const closeVideoBtn = document.querySelector('.pip-close-icon') as HTMLElement;
            episodesMenu.style.display = 'flex';
            this.showTimer = true;
            setTimeout(() => {
                episodesMenu.classList.add('visible');
                closeVideoBtn.style.display = 'none';
            }, 50);
            this.timerValue = 15;
            const timer$ = interval(1000).pipe(
                take(15),
                map((value) => 14 - value)
            );
            this.timerFirstTime = false;

            this.timerSubscription = timer$.subscribe(
                (value) => {
                    this.timerValue = value;
                },
                (error) => {
                    console.error(error);
                },
                () => {
                    if (!this.isLastEpisode) this.goToNextEpisode();
                    else this.goToAssetGroupPage();
                }
            );
        } else if (currentTime < this.creditsStart) {
            this.stopTimer();
        }
    }

    onImageError(event) {
        event.target.src = this.imagePrefix + 'horizontal.png';
        event.target.onerror = null;
    }

    skipIntro() {
        this.playerObject.currentTime = this.introEnd;

        this.showSkipButton = false;
    }

    stopTimer(): void {
        if (this.showTimer) {
            this.showTimer = false;
            this.timerFirstTime = false;
            if (this.timerSubscription) {
                this.timerSubscription.unsubscribe();
                this.timerSubscription = null;
            }
        }
    }

    repeatContent() {
        this.playerObject.currentTime = 0;
    }

    goToNextEpisode() {
        if (Array.isArray(this.episodesList)) {
            this.episodesList.forEach((episode, i) => {
                if (
                    episode.path === this.assetData.path &&
                    Array.isArray(this.episodesList) &&
                    i < this.episodesList.length - 1
                ) {
                    this.goToAssetVideo(
                        this.episodesList[i + 1].title,
                        this.episodesList[i + 1].path
                    );
                }
            });
        }
    }

    isLastEpisodeInSeason() {
        if (Array.isArray(this.episodesList)) {
            this.episodesList.forEach((episode, i) => {
                if (
                    episode.path === this.assetData.path &&
                    Array.isArray(this.episodesList) &&
                    i === this.episodesList.length - 1
                ) {
                    this.isLastEpisode = true;
                }
            });
        }
    }

    public async addBookmark() {
        try {
            await addBookmark({
                assetId: this.assetId,
                duration: this.playerObject.currentTime,
            });
        } catch (error) {
            console.log(error);
        }
    }

    async ngOnDestroy() {
        if (this.addBookmarkInterval) {
            clearInterval(this.addBookmarkInterval);
        }
        if (this.playerObject) {
            if (this.isLoggedIn && this.setBookmark && this.isGeolocationAllowed) {
                this.addBookmark();
                document.removeEventListener('keydown', this.getPressedKey.bind(this));
            }
            this.playerObject.destroy();
        }
    }

    playVideo() {
        if (!this.playerObject) return
        this.playerObject.play();
    }

    // Hotkeys functions
    togglePlay() {
        if (this.playerObject.paused) {
            this.showActionIndicator = true;
            this.playerObject.play();
            this.actionIndicator = { icon: 'play.svg', animationClass: 'play-animation' };
            this.timeoutId = setTimeout(() => {
                this.showActionIndicator = false;
            }, 1000);
        } else {
            this.showActionIndicator = true;
            this.playerObject.pause();
            this.actionIndicator = { icon: 'pause.svg', animationClass: 'pause-animation' };
            this.timeoutId = setTimeout(() => {
                this.showActionIndicator = false;
            }, 1000);
        }
    }

    rewind() {
        this.showActionIndicator = true;
        this.playerObject.currentTime -= 10; //Subtracts 10 seconds
        this.actionIndicator = { icon: 'backward.svg', animationClass: 'rewind-animation' };
        this.timeoutId = setTimeout(() => {
            this.showActionIndicator = false;
        }, 1000);
    }

    forward() {
        this.showActionIndicator = true;
        this.playerObject.currentTime += 10; //Adds 10 seconds
        this.actionIndicator = { icon: 'forward.svg', animationClass: 'forward-animation' };
        this.timeoutId = setTimeout(() => {
            this.showActionIndicator = false;
        }, 1000);
    }

    increaseVolume() {
        this.showActionIndicator = true;
        this.playerObject.volume = Math.min(this.playerObject.volume + 0.05, 1); //Increases volume by 5%
        this.actionIndicator = {
            icon: 'volume-up.svg',
            animationClass: 'increase-volume-animation',
        };
        this.timeoutId = setTimeout(() => {
            this.showActionIndicator = false;
        }, 1000);
    }

    decreaseVolume() {
        this.showActionIndicator = true;
        this.playerObject.volume = Math.max(this.playerObject.volume - 0.05, 0); //Lowers volume by 5%
        this.actionIndicator = {
            icon: 'volume-down.svg',
            animationClass: 'decrease-volume-animation',
        };
        this.timeoutId = setTimeout(() => {
            this.showActionIndicator = false;
        }, 1000);
    }

    toggleFullScreen() {
        if (this.playerObject.presentation.currentMode === 'fullscreen') {
            this.playerObject.presentation.requestMode('inline');
        } else {
            this.playerObject.presentation.requestMode('fullscreen');
        }
    }

    toggleMute() {
        this.showActionIndicator = true;
        this.playerObject.muted = !this.playerObject.muted;
        if (!this.playerObject.muted) {
            this.actionIndicator = { icon: 'volume-up.svg', animationClass: 'mute-animation' };
        } else {
            this.actionIndicator = { icon: 'volume-off.svg', animationClass: 'mute-animation' };
        }
        this.timeoutId = setTimeout(() => {
            this.showActionIndicator = false;
        }, 1000);
    }

    preventStandardHotKeyActions(event) {
        event.stopPropagation();
        event.preventDefault();
    }
    getPressedKey(event) {
        const pressedKey = event.key;
        this.showActionIndicator = false;

        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
        let action;
        setTimeout(() => {
            switch (pressedKey) {
                case ' ':
                    action = this.togglePlay();
                    break;
                case 'ArrowLeft':
                    if (!this.isAdPlaying) {
                        action = this.rewind();
                    }
                    break;
                case 'ArrowRight':
                    if (!this.isAdPlaying) {
                        action = this.forward();
                    }
                    break;
                case 'ArrowUp':
                    action = this.increaseVolume();
                    break;
                case 'ArrowDown':
                    action = this.decreaseVolume();
                    break;
                case 'f':
                    action = this.toggleFullScreen();
                    break;
                case 'm':
                    action = this.toggleMute();
                    break;
            }
        }, 10);
        if (action && pressedKey !== 'Control' && pressedKey !== 'Alt' && pressedKey !== 'Shift') {
            action();
            this.preventStandardHotKeyActions(event); //Stops the default key behavior like jumping the page with space.
        }
    }
}
